__turbopack_context__.v({
  "className": "montserrat_2d0bc7d4-module__A3r0KW__className",
  "variable": "montserrat_2d0bc7d4-module__A3r0KW__variable",
});
